import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { useClassnames } from 'hook/use-classnames';
import useLogout from 'hook/use-logout';
import UI from 'component/ui';
import Button from 'component/button';

import { IStore } from 'src/types/reducers';
import { key as keyUser } from 'component/user/reducer';

import style from './index.pcss';

const Tasks = () => {
    const cn = useClassnames(style);

    const isAuth = useSelector<IStore, boolean>((store) => !!store[keyUser].id);
    const username = useSelector<IStore, string | undefined>((store) => store[keyUser].username);

    const [onClickLogout, pending] = useLogout();

    if (!isAuth) {
        return <Navigate to="/login" replace={true} />;
    }

    return (
        <UI.Main className={cn('profile')}>
            <h1 className={cn('profile__header')}>
                Пользователь: {username}
            </h1>
            <div className={cn('profile__desc')}>
                <Button onClick={onClickLogout} disabled={pending} className={cn('profile__button')}>
                    Выйти
                </Button>
            </div>
        </UI.Main>
    );
};

export default Tasks;
